// src/components/Spinner.js
export default function Spinner({ size = 36, color = "#1a6b3c" }) {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: 40 }}>
      <div style={{
        width: size, height: size, border: `3px solid #e2ece2`,
        borderTop: `3px solid ${color}`, borderRadius: "50%",
        animation: "spin 0.7s linear infinite"
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
